export const SITE = {
  name: "Airconditioning Victoria",
  legalName: "AIRCONDITIONING VICTORIA PTY. LTD.",
  abn: "98 080 573 762",
  phone: "+61 423 250 130",
  phoneHref: "tel:+61423250130",
  email: "admin@airconditioningvictoria.com.au",
  emailHref: "mailto:admin@airconditioningvictoria.com.au",
  address1: "5/4 Vesper Drive",
  address2: "Narre Warren VIC 3805",
  domain: "https://airconditioningvictoria.com.au",
  established: "2000",
};

export const IMAGES = {
  heroExterior:
    "https://images.unsplash.com/photo-1785553777926-bc3e2332e291?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhdXN0cmFsaWFuJTIwaG9tZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4OTE5NDAxN3ww&ixlib=rb-4.1.0&q=85",
  technician:
    "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  technician2:
    "https://images.pexels.com/photos/5463575/pexels-photo-5463575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  splitInterior:
    "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25lciUyMGludGVyaW9yfGVufDB8fHx8MTc4OTE5NDAxN3ww&ixlib=rb-4.1.0&q=85",
  splitInterior2:
    "https://images.unsplash.com/photo-1759772238012-9d5ad59ae637?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxhaXIlMjBjb25kaXRpb25lciUyMGludGVyaW9yfGVufDB8fHx8MTc4OTE5NDAxN3ww&ixlib=rb-4.1.0&q=85",
  livingRoom:
    "https://images.unsplash.com/photo-1596204976717-1a9ff47f74ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBjb21mb3J0YWJsZSUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg5MTk0MDE3fDA&ixlib=rb-4.1.0&q=85",
  houseExterior2:
    "https://images.unsplash.com/photo-1785554997581-3c7100703339?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhdXN0cmFsaWFuJTIwaG9tZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4OTE5NDAxN3ww&ixlib=rb-4.1.0&q=85",
};

export const BRANDS = [
  { name: "Mitsubishi Electric", logo: "/assets/brands/mitsubishi-electric.png" },
  { name: "Daikin", logo: "/assets/brands/daikin.png" },
  { name: "Fujitsu", logo: "/assets/brands/fujitsu.png" },
  { name: "Panasonic", logo: "/assets/brands/panasonic.png" },
  { name: "Samsung", logo: "/assets/brands/samsung.png" },
  { name: "Carrier", logo: "/assets/brands/carrier.png" },
  { name: "Braemar", logo: "/assets/brands/braemar.png" },
  { name: "Brivis", logo: "/assets/brands/brivis.png" },
  { name: "Coolair", logo: "/assets/brands/coolair.png" },
];
